import React, { FC, Dispatch, SetStateAction } from 'react'
import Modal from 'ps-components/Modal/Modal';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import ModalFooter from 'ps-components/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import { UseMutateFunction } from 'react-query';

type Props = {
    open: boolean
    setIsOpen: Dispatch<SetStateAction<boolean | undefined>>
    onSubmit: UseMutateFunction<void, unknown, void, unknown>
}

export const ConfirmationModal: FC<Props> = ({ open, setIsOpen, onSubmit }) => {
    return (
        <Modal onClose={setIsOpen} show={open}>
            <ModalHeader>
            <h3>
                Please Confirm
            </h3>
            </ModalHeader>
            <ModalBody>
                <p>
                Note: When copying over a participation report template, everything will be copied over as is from the previous year/Survey Participation Report.
                Users should ensure all filters, formulas, columns, etc. are updated to reflect the requirements of the current year's Survey Participation Report.
                </p>
            </ModalBody>
            <ModalFooter cancelBtnClick={setIsOpen} submitBtnClick={onSubmit} submitBtnTxtName="Okay" hideCancelButton={true} />
        </Modal>
    )
}